import React from 'react'
import ExpandablePanel from '../controls/ExpandablePanel'
import KasKrs from '../KasKrs'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import ChipInput from 'material-ui-chip-input'
import { controlHasError } from '../../lib/errorHandler'

class IdentyfikacjaPodmiotu extends React.Component {
  handleAddChip = chip => {
    const { data, onSetSectionData } = this.props
    const newPKD = [...data.PKD, chip]
    onSetSectionData('PKD', newPKD)
  }

  handleDeleteChip = (chip, index) => {
    const { data, onSetSectionData } = this.props
    const newPKD = [...data.PKD]
    newPKD.splice(index, 1)
    onSetSectionData('PKD', newPKD)
  }

  render() {
    const {
      errors,
      data,
      onSetSectionData,
      onSetKRS,
      onLoadGUS,
      onSetName,
    } = this.props
    return (
      <ExpandablePanel title="IDENTYFIKACJA PODMIOTU">
        <form
          name="IdentyfikacjaPodmiotu"
          autoComplete="off"
          className="identyfikacjaPodmiotu"
        >
          <KasKrs
            className="kasKrs"
            hasError={name => controlHasError(errors, name)}
            data={{
              CzyKRS: data.CzyKRS,
              IdentyfikatorPodmiotu: data.IdentyfikatorPodmiotu,
            }}
            onSetSectionData={e => {
              if (e.target.name === 'CzyKRS') {
                onSetSectionData(e.target.name, e.target.value === 'true')
                onSetKRS(e.target.value === 'true')
              } else onSetSectionData(e.target.name, e.target.value)
            }}
            onLoadGUS={onLoadGUS}
          />
          <FormControl component="fieldset" className="nazwa">
            <TextField
              error={controlHasError(errors, 'NazwaFirmy')}
              name="NazwaFirmy"
              label="Nazwa pełna"
              title={data.NazwaFirmy}
              value={data.NazwaFirmy}
              onChange={e => {
                onSetSectionData(e.target.name, e.target.value)
                onSetName(e.target.value)
              }}
            />
          </FormControl>
          <FormControl component="fieldset" className="pkd">
            <ChipInput
              error={controlHasError(errors, 'PKD')}
              InputLabelProps={{ shrink: true }}
              name="PKD"
              label="Kody PKD"
              placeholder="Wpisz kod + [ENTER]"
              value={data.PKD}
              onAdd={this.handleAddChip}
              onDelete={this.handleDeleteChip}
              helperText="Pojedynczy kod: 5 znaków, bez kropek"
            />
          </FormControl>
        </form>
      </ExpandablePanel>
    )
  }
}

export default IdentyfikacjaPodmiotu
